import { jsx as n } from "react/jsx-runtime";
import { cva as i } from "class-variance-authority";
import { cn as a } from "../../lib/utils.js";
function d({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    "div",
    {
      "data-slot": "empty",
      className: a(
        "flex w-full min-w-0 flex-1 flex-col items-center justify-center gap-4 rounded-xl border-dashed p-6 text-center text-balance",
        e
      ),
      ...t
    }
  );
}
function c({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    "div",
    {
      "data-slot": "empty-header",
      className: a("flex max-w-sm flex-col items-center gap-2", e),
      ...t
    }
  );
}
const s = i(
  "mb-2 flex shrink-0 items-center justify-center [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        icon: "flex size-8 shrink-0 items-center justify-center rounded-lg bg-muted text-foreground [&_svg:not([class*='size-'])]:size-4"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function f({
  className: e,
  variant: t = "default",
  ...r
}) {
  return /* @__PURE__ */ n(
    "div",
    {
      "data-slot": "empty-icon",
      "data-variant": t,
      className: a(s({ variant: t, className: e })),
      ...r
    }
  );
}
function u({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    "div",
    {
      "data-slot": "empty-title",
      className: a(
        "font-heading text-sm font-medium tracking-tight",
        e
      ),
      ...t
    }
  );
}
function p({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    "div",
    {
      "data-slot": "empty-description",
      className: a(
        "text-sm/relaxed text-muted-foreground [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary",
        e
      ),
      ...t
    }
  );
}
function x({ className: e, ...t }) {
  return /* @__PURE__ */ n(
    "div",
    {
      "data-slot": "empty-content",
      className: a(
        "flex w-full max-w-sm min-w-0 flex-col items-center gap-2.5 text-sm text-balance",
        e
      ),
      ...t
    }
  );
}
export {
  d as Empty,
  x as EmptyContent,
  p as EmptyDescription,
  c as EmptyHeader,
  f as EmptyMedia,
  u as EmptyTitle
};
//# sourceMappingURL=empty.js.map
